<template>
  <v-container>
    <v-layout row wrap>
      <v-flex>
        <info-table
          :roleLinkField="roleLinkField"
          :roleLinkParam="roleLinkParam"
          :profile="profile"
          :updatePermissions="['PROFILE.UPDATE', 'PARTNER.EMPLOYEE_UPDATE']"
          @showEditModal="showEditModal"
        />
      </v-flex>
    </v-layout>

    <modal :show="showModal" :id="editId" :edit="!!editId" @close="hideModal" @update="update" />
  </v-container>
</template>

<script>
import { isOfficial } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import { modalMixin } from '@/mixins/modal';
import store from '@/store/store';
import InfoTable from '@/views/profile/InfoTable';
import Modal from './modals/Employee.modal';

/**
 * @vuese
 * Profil
 * @group employees
 */
export default {
  components: {
    InfoTable,
    Modal
  },
  mixins: [
    modalMixin('employees', {
      getError: 'Wystąpił błąd podczas pobierania danych pracownika.',
      updated: 'Zaktualizowano dane pracownika.',
      updateError: 'Nie udało się zaktualizować danych pracownika.'
    })
  ],
  async beforeRouteUpdate(to, from, next) {
    try {
      store.commit('employees/setId', to.params.employeeId);

      await store.dispatch('employees/get');
      next();
    } catch (error) {
      store.dispatch('notifyError', { title: 'Nie udało się pobrać danych pracownika' });
    }
  },

  computed: {
    ...mapState({
      profile: state => state.employees.data.profile,
      editId: state => state.employees.data.profile.id.toString()
    }),
    roleLinkField() {
      return isOfficial() ? 'employeeOfficialRoles' : 'employeePartnerRoles';
    },
    roleLinkParam() {
      return isOfficial() ? 'employeeId' : 'id';
    }
  }
};
</script>
